export const USER_ADDRESS_REQUEST = "USER_ADDRESS_REQUEST";
export const USER_ADDRESS_SUCCESS = "USER_ADDRESS_SUCCESS";
export const USER_ADDRESS_FAIL = "ALL_ADDRESSES_REQUESTS_FAIL";

export const ADD_ADDRESS_REQUEST = "ADD_ADDRESS_REQUESTS";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_FAIL = "ADD_ADDRESS_FAIL";

export const REMOVE_ADDRESS_REQUEST = "REMOVE_ADDRESS_REQUEST";
export const REMOVE_ADDRESS_SUCCESS = "REMOVE_ADDRESS_SUCCESS";
export const REMOVE_ADDRESS_FAIL = "REMOVE_ADDRESS_FAIL";

